import React from "react";
import Marquee from "react-fast-marquee";

const items = ["MEGAWIN5K", "PREMIUM GAMING", "JAKARTA · INDONESIA", "GET DIRECTIONS"];

export const BrandMarquee = () => (
  <section aria-hidden="true" data-testid="brand-marquee" className="py-10 border-y border-white/10 bg-black/40">
    <Marquee speed={28} gradient={false} className="overflow-hidden">
      {items.concat(items).map((t, i) => (
        <span
          key={i}
          className="font-display font-black text-4xl md:text-6xl text-stroke mx-8 tracking-tighter"
        >
          {t} <span className="text-neon not-italic">•</span>
        </span>
      ))}
    </Marquee>
  </section>
);
